/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ track: NonNullable<unknown> }} Split_Multiview_Track_LabelInputs */



/**
* | output |
* | --- |
* | "Track {track}" |
*
* @param {Split_Multiview_Track_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const split_multiview_track_label = /** @type {((inputs: Split_Multiview_Track_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Split_Multiview_Track_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Piste ${i?.track}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Track ${i?.track}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Traccia ${i?.track}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Трек ${i?.track}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Pista ${i?.track}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`追踪${i?.track}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`トラック ${i?.track}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`ट्रैक ${i?.track}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Faixa ${i?.track}`)
	return /** @type {LocalizedString} */ (`Track ${i?.track}`)
});